import React, { createContext, useContext, useState, useEffect } from 'react'

export const THEMES = {
  AURORA: 'aurora',
  SUNSET: 'sunset',
  EMERALD: 'emerald',
  LIGHT: 'light'
}

export const THEME_CONFIGS = [
  {
    id: THEMES.AURORA,
    name: 'Cosmic Aurora',
    icon: '🌌',
    description: 'Deep indigo & cyan aurora with starry sky',
    previewColor: '#6366f1'
  },
  {
    id: THEMES.SUNSET,
    name: 'Sunset Amber',
    icon: '🌅',
    description: 'Warm crimson & golden amber glow',
    previewColor: '#f97316'
  },
  {
    id: THEMES.EMERALD,
    name: 'Emerald Cyber',
    icon: '🌿',
    description: 'Deep obsidian & neon mint accents',
    previewColor: '#10b981'
  },
  {
    id: THEMES.LIGHT,
    name: 'Frost Glass',
    icon: '✨',
    description: 'Frosted pearl glass & crisp minimalist layout',
    previewColor: '#3b82f6'
  }
]

const ThemeContext = createContext({
  theme: THEMES.AURORA,
  setTheme: () => {},
  toggleTheme: () => {}
})

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try {
      const savedTheme = localStorage.getItem('dasyam_site_theme')
      if (savedTheme && Object.values(THEMES).includes(savedTheme)) {
        return savedTheme
      }
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
        return THEMES.LIGHT
      }
    } catch (e) {
      // Fallback if localStorage is unavailable
    }
    return THEMES.AURORA
  })

  useEffect(() => {
    try {
      document.documentElement.setAttribute('data-theme', theme)
      localStorage.setItem('dasyam_site_theme', theme)
    } catch (e) {
      console.warn('Failed to save theme in localStorage', e)
    }
  }, [theme])

  const toggleTheme = () => {
    setTheme(prev => {
      if (prev === THEMES.AURORA) return THEMES.SUNSET
      if (prev === THEMES.SUNSET) return THEMES.EMERALD
      if (prev === THEMES.EMERALD) return THEMES.LIGHT
      return THEMES.AURORA
    })
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, themeConfigs: THEME_CONFIGS }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext)

export default ThemeContext
